import script from "./TextInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextInput.vue?vue&type=script&lang=ts&setup=true"

import "./TextInput.vue?vue&type=style&index=0&id=2881ca20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2881ca20"]])

export default __exports__